import { percentageFilter } from "app/filters/ngFilters";
import type { FC } from "react";
import styled from "styled-components";
import type { ITableCellProps } from "../interfaces/ITableCellProps";
interface IPercentageCellProps {
    percentageCellFilterFraction?: number;
    urlLink?: string;
}

export const PercentageCell: FC<IPercentageCellProps & ITableCellProps> = (props) => {
    const { value, className, percentageCellFilterFraction: fraction = 2, urlLink, row } = props;
    const valuePercents = percentageFilter()(value || 0, fraction) + "%";

    return (
        <div className={className}>
            {urlLink ? (
                <a
                    href={urlLink}
                    target="_self"
                    className="cell-clickable"
                >
                    {valuePercents}
                </a>
            ) : (
                <span className="min-value">{valuePercents}</span>
            )}
        </div>
    );
};
PercentageCell.displayName = "PercentageCell";

export const PercentageCellRightAlign = styled(PercentageCell)`
    text-align: right;
`;
